import React from "react";
import styled from "@emotion/styled";

interface LoadingProps {
    /** Mensagem dinâmica exibida na parte inferior */
    message: string;
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.85); /* Mantido rgba para o efeito de opacidade */
  backdrop-filter: blur(2px);
  z-index: 99999;
`;

const SpinnerWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background: white; /* bg-white */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2); /* Sombra específica */
  z-index: 99999;

  img {
    width: 60%;
    height: 60%;
    object-fit: contain;
  }
`;

const TextMessage = styled.p`
  position: fixed;
  bottom: 2rem; /* 32px usando rem */
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  font-size: var(--fs-body); /* Usando Design Token para 1rem */
  font-weight: 500;
  color: var(--brand-500); /* Usando Design Token para a cor principal da marca */
  animation: blink 1.2s infinite;
  z-index: 99999;

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
`;

const Loading: React.FC<LoadingProps> = ({ message }) => {
    return (
        <>
            <Overlay />
            <SpinnerWrapper>
                <img src="/loading.gif" alt="Carregando" />
            </SpinnerWrapper>
            <TextMessage>{message}</TextMessage>
        </>
    );
};

export default Loading;